import useRepo from '@/nebula/repo';
import { notificationSetting as notificationSettingConfig } from 'shared/api/query/configs.json';

export default function useNotificationSettings() {
  return useRepo(notificationSettingConfig.model);
}
